import React, {useState} from 'react';
import {useLocation, useNavigate} from 'react-router-dom';
import '../styles/layout/layout.css';



const Navigation = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [userState, setUserState] = useState(null);

    const menuItems = [
        {id: 1, name: '현장정보등록', path: '/'},
        {id: 2, name: 'USER정보등록', path: '/userRegistration'},
        {id: 3, name: 'NFC등록관리', path: '/nfcManagement'},
        {id: 4, name: '기록정보확인', path: '/recordInfo'},
    ];

    const handleLogout = () => {
        localStorage.removeItem('user');
        setIsLoggedIn(false);
        setUserState(null);
        navigate('/login');
    };

    return (
        <div className="navigation">
            <ul>
                {menuItems.map(item => (
                    <li
                        key={item.id}
                        className={`navigation-item ${location.pathname === item.path ? 'active' : ''}`}
                        onClick={() => navigate(item.path)}
                    >
                        {item.name}
                    </li>
                ))}
            </ul>

            <div className="qr-button-wrapper">
                <a href="/assets/images/qrcode_ddpartners.png" download="qrcode.png" className="qr-button">QR 이미지 다운</a>
                <button onClick={handleLogout}>
                    로그아웃
                </button>
            </div>

        </div>
    );
};

export default Navigation;
